<template>
    <Header subTitle="Un site qui évolue avec vous" />

    <Main>
        <FullContainerWithMedia>
            <h2>
                Gérez votre contenu en toute autonomie
            </h2>
            <p>
                Grâce à une interface simple et intuitive, mettez à jour votre site sans écrire une ligne de code. Une
                interface créer uniquement pour vous vous permettra d'ajouter, modifier ou supprimer articles, images et
                pages en quelques clics. L'équipe marketing gagne en liberté : planifiez, ajustez et testez vos contenus
                en temps réel, sans dépendre des développeurs. Simplicité, rapidité et flexibilité réunies !
            </p>
            <template #img>
                <img src="~/assets/images/demo-prismic.png" alt="Gestion de contenu avec Prismic" />
            </template>
        </FullContainerWithMedia>
        <FullContainerWithMedia reversed>
            <h2>
                Un design adapté à votre image
            </h2>
            <p>
                Chaque entreprise est unique, et votre site doit l'être aussi. Grâce à notre approche personnalisée,
                créez un site qui reflète parfaitement votre identité visuelle. Couleurs, typographies, mises en page :
                tout est ajusté pour correspondre à vos valeurs et à votre audience. Un design sur-mesure pour une
                expérience utilisateur optimale !
            </p>
            <template #video>
                <video controls muted loop>
                    <source src="~/assets/videos/amesun-vid.mp4" type="video/mp4" alt="Full website demo" />
                </video>
            </template>
        </FullContainerWithMedia>
        <FullContainer>
            <h2>
                Rapide et efficace
            </h2>
            <p>
                Nous utilisons des outils modernes qui garantissent une navigation fluide et agréable.
                Votre site se charge rapidement, s'adapte à tous les écrans et offre une expérience optimale à vos
                visiteurs.
                Résultat : plus de visibilité, plus de performance et une image professionnelle renforcée.
            </p>
        </FullContainer>

        <Tariffs>
            <h2>
                Nos Tarifs
            </h2>
            <p>
                Offrez à votre entreprise une vitrine en ligne professionnelle et évolutive.
                Un site multi-pages optimisé, avec CMS classique ou headless, pour gérer facilement vos contenus et
                booster votre image de marque.
            </p>
            <template #table>
                <table class="tariffs-table" cellpadding="10" cellspacing="0"
                    style="border-collapse: collapse; width: 100%; text-align: center; font-family: Arial, sans-serif;">
                    <thead style="background-color: #f4f4f4;">
                        <tr>
                            <th>Option</th>
                            <th>Description</th>
                            <th>Prix à partir de (€)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Design personnalisé</td>
                            <td>Maquettes UX/UI, identité visuelle, responsive</td>
                            <td>500 €</td>
                        </tr>
                        <tr>
                            <td>Développement front-end</td>
                            <td>Intégration HTML, CSS, JS (site vitrine multi-pages)</td>
                            <td>800 €</td>
                        </tr>
                        <tr>
                            <td>Développement back-end</td>
                            <td>Fonctionnalités spécifiques (formulaires, base de données, espace client...)</td>
                            <td>1 200 €</td>
                        </tr>
                        <tr>
                            <td>CMS Headless</td>
                            <td>Gestion de contenu simplifiée via interface</td>
                            <td>1 500 €</td>
                        </tr>
                        <tr>
                            <td>Hébergement</td>
                            <td>Serveur mutualisé ou dédié + SSL</td>
                            <td>10 €/mois</td>
                        </tr>
                        <tr>
                            <td>Maintenance / Support</td>
                            <td>Mises à jour, sauvegardes, correctifs</td>
                            <td>80 €/mois</td>
                        </tr>
                        <tr>
                            <td>Option QR Code</td>
                            <td>QR Code redirigeant vers le site ou une page spécifique</td>
                            <td>30 €</td>
                        </tr>
                        <tr style="background-color: #f0f8ff; font-weight: bold;">
                            <td>Pack complet</td>
                            <td>Design + Dev front & back + CMS headless</td>
                            <td>4 500 €</td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </Tariffs>
    </Main>
</template>

<script setup>
useSeoMeta({
    title: "Byte Hive — Sites Web : autonomie, performance & sur-mesure",
    description: "Créez un site web qui évolue avec vous : interface simple, design personnalisé, performance et autonomie. Gérez vos contenus sans coder avec Byte Hive.",
    ogTitle: "Byte Hive — Sites Web performants & autonomes",
    ogDescription: "Un site web taillé pour votre image, rapide, responsive et facile à administrer. Avec Byte Hive, prenez le contrôle de votre présence en ligne.",
    ogImage: "https://byte-hive.fr/byte-hive-og-image.png",
    ogUrl: "https://byte-hive.fr/websites",
    ogType: "website"
});
</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
